import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState } from '../loader/loader.model';

@Injectable()
export class LoaderService {

  public loaderSubject = new Subject<LoaderState>();

  loaderState = this.loaderSubject.asObservable();

  constructor() { }

  show(url: string) {
    this.loaderSubject.next(<LoaderState>{ show: true, url: url });
  }

  hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }

}
